/* CERTIFICACIONES — el expediente se abre en una ventana, sin salir de la pagina.

   ⚠️ LO QUE SE MUESTRA ES UNA IMAGEN DE LA HOJA, NO EL PDF ADENTRO DE UN
   IFRAME. La primera version usaba <iframe src="...pdf"> y en celular no
   servia: Safari de iOS no dibuja un PDF adentro de un iframe y deja el
   recuadro en blanco. Mark lo pidio igual para celular, con razon, asi que se
   cambio el enfoque en vez de dejarlo a medias.
   La caratula es una hoja de texto: una imagen de la pagina 1 se ve igual,
   carga mas rapido y se comporta igual en todos los navegadores. El PDF
   completo sigue a un click, en el pie de la ventana, para el que quiera el
   documento firmado.
   Las imagenes se generaron con PyMuPDF a 2.2x y viven en Shopify Files.

   La hoja se carga recien cuando se abre la ventana: si el src estuviera
   puesto desde el principio, la pagina se bajaria las dos hojas al entrar. */
(function(){
  var seccion = document.querySelector('.rz-cert');
  if(!seccion) return;

  var botones = seccion.querySelectorAll('[data-cert-ver]');
  if(!botones.length) return;

  var caja=null, hoja=null, titulo=null, afuera=null, devolver=null;

  function armar(){
    if(caja) return caja;
    caja=document.createElement('div');
    caja.className='rz-cert__modal';
    caja.setAttribute('aria-hidden','true');
    caja.innerHTML =
      '<div class="rz-cert__modal-tapa" data-cert-cerrar></div>'
    + '<div class="rz-cert__modal-panel" role="dialog" aria-modal="true" aria-label="Expediente">'
    +   '<header class="rz-cert__modal-bar">'
    +     '<h2></h2>'
    +     '<button type="button" class="rz-cert__modal-x" data-cert-cerrar aria-label="Cerrar">'
    +       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
    +     '</button>'
    +   '</header>'
    +   '<div class="rz-cert__modal-cuerpo"><img alt="" decoding="async"></div>'
    +   '<footer class="rz-cert__modal-pie">'
    +     '<a target="_blank" rel="noopener">Descargar el PDF firmado</a>'
    +   '</footer>'
    + '</div>';
    document.body.appendChild(caja);
    hoja   = caja.querySelector('.rz-cert__modal-cuerpo img');
    titulo = caja.querySelector('.rz-cert__modal-bar h2');
    afuera = caja.querySelector('.rz-cert__modal-pie a');
    caja.addEventListener('click', function(e){
      if(e.target.closest('[data-cert-cerrar]')) cerrar();
    });
    return caja;
  }

  function abrir(pdf, img, nombre){
    armar();
    titulo.textContent = nombre;
    afuera.href = pdf;
    hoja.alt = 'Carátula del expediente de ' + nombre;
    hoja.src = img;
    caja.querySelector('.rz-cert__modal-cuerpo').scrollTop = 0;
    caja.classList.add('is-open');
    caja.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    devolver = document.activeElement;
    caja.querySelector('.rz-cert__modal-x').focus();
  }

  function cerrar(){
    if(!caja) return;
    caja.classList.remove('is-open');
    caja.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
    if(devolver && devolver.focus) devolver.focus();
  }

  document.addEventListener('keydown', function(e){
    if(e.key==='Escape' && caja && caja.classList.contains('is-open')) cerrar();
  });

  for(var i=0;i<botones.length;i++){
    botones[i].addEventListener('click', function(e){
      var pdf = this.getAttribute('data-cert-ver');
      var img = this.getAttribute('data-cert-hoja');
      var nombre = this.getAttribute('data-cert-nombre') || 'Expediente';
      /* Sin imagen de la hoja no hay nada que mostrar en la ventana: se deja
         que el link haga lo suyo y abra el PDF. */
      if(!pdf || !img) return;
      e.preventDefault();
      abrir(pdf, img, nombre);
    });
  }
})();
